import React from 'react'
import intl from 'react-intl-universal';

export default function CouponType({ couponType }) {
    let couponTypeStr = '';
    if (couponType === 1) {
        couponTypeStr = intl.get('od_full_reduce_coupon').d('满减券');
    } else if (couponType === 2) {
        couponTypeStr = intl.get('od_discount_coupon').d('折扣券');
    } else if (couponType === 3) {
        couponTypeStr = intl.get('equity_gift_coupon').d('礼品券');
    }
    return (
        <div>{couponTypeStr}</div>
    )
}
